export default {
  props: {
    primaryKey: { type: String },
    primaryKeyField: { type: String },
    identity: { type: String, required: true },
    displayField: { type: String },
    name: { type: String },
    pluralName: { type: String },
  },
  computed: {
  },
  methods: {
  }
};
